import React from 'react';

const Table = ({ children, className = '', ...props }) => {
  return (
    <div
      className={`overflow-x-auto rounded-2xl border border-ink-200 bg-white shadow-soft ${className}`}
    >
      <table className="w-full text-sm" {...props}>
        {children}
      </table>
    </div>
  );
};

const TableHeader = ({
  children,
  className = '',
  onClick,
  sortable = false,
  sortDirection = null,
  ...props
}) => {
  const headerClasses = [
    'px-4 py-3 text-left text-[11px] font-semibold text-ink-500 uppercase tracking-wider',
    sortable ? 'cursor-pointer hover:text-ink-700 select-none' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <th className={headerClasses} onClick={onClick} {...props}>
      {sortable ? (
        <div className="inline-flex items-center gap-1">
          <span>{children}</span>
          {sortDirection && (
            <span className="text-ink-400">
              {sortDirection === 'asc' ? '↑' : '↓'}
            </span>
          )}
        </div>
      ) : (
        children
      )}
    </th>
  );
};

const TableRow = ({ children, className = '', ...props }) => {
  return (
    <tr
      className={`hover:bg-ink-50/60 transition-colors ${className}`}
      {...props}
    >
      {children}
    </tr>
  );
};

const TableCell = ({ children, className = '', ...props }) => {
  return (
    <td className={`px-4 py-3.5 align-middle text-ink-800 ${className}`} {...props}>
      {children}
    </td>
  );
};

const TableBody = ({ children, className = '', ...props }) => {
  return (
    <tbody
      className={`bg-white divide-y divide-ink-100 ${className}`}
      {...props}
    >
      {children}
    </tbody>
  );
};

const TableHead = ({ children, className = '', ...props }) => {
  return (
    <thead
      className={`bg-ink-50/70 border-b border-ink-200 ${className}`}
      {...props}
    >
      {children}
    </thead>
  );
};

Table.Header = TableHeader;
Table.Row = TableRow;
Table.Cell = TableCell;
Table.Body = TableBody;
Table.Head = TableHead;

export default Table;
